<form>
  <div>
    <mat-form-field class="m-1 w-100">
      <mat-label>Address Line 1</mat-label>
      <input matInput required name="addressLine1" [(ngModel)]="address.addressLine1">
    </mat-form-field>
  </div>
  <div>
    <mat-form-field class="m-1 w-100">
      <mat-label>Address Line 2</mat-label>
      <input matInput name="addressLine2" [(ngModel)]="address.addressLine2">
    </mat-form-field>
  </div>
  <div>
    <mat-form-field class="m-1 w-100">
      <mat-label>City</mat-label>
      <input matInput required name="city" [(ngModel)]="address.city">
    </mat-form-field>
  </div>

  <div>
    <mat-form-field appearance="fill">
      <mat-label>Country</mat-label>
      <mat-select [(value)]="address.countryId" (selectionChange)='onCountryChanged($event)' required>
        <mat-option></mat-option>
        @for (country of countries; track country) {
        <mat-option [value]="country.id">{{ country.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div>
    <mat-form-field appearance="fill">
      <mat-label>State/Province</mat-label>
      <mat-select [(value)]="address.stateOrProvinceId" required>
        <mat-option></mat-option>
        @for (state of states; track state) {
        <mat-option [value]="state.id">{{ state.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div>
    <mat-form-field class="m-1 w-100">
      <mat-label>Postal/Zip Code</mat-label>
      <input matInput name="zipOrPostalCode" [(ngModel)]="address.zipOrPostalCode" required>
    </mat-form-field>
  </div>
</form>